import PropTypes from 'prop-types';

import { BOYSENBERRY_S3_IMAGES } from 'constants';
import Button from 'honeydew/Button';

function ProspectModule({ onSignUpCTAClick, renderSignUpCTA }) {
    return (
        <section className="bg-malt px-25 py-30" data-optimizely-id="what-is-misfits-market">
            <h1 className="text-heading-sm md:text-center">What is Misfits Market?</h1>
            <div className="mx-auto my-30 flex max-w-[1000px] flex-col justify-center gap-30 md:flex-row">
                <div className="text-body-sm flex flex-1 flex-col gap-10">
                    <img
                        alt="Hand holding a green pepper"
                        src={`${BOYSENBERRY_S3_IMAGES}signup/w_550,h_550/mm-pepper.png`}
                        width={550}
                        height={550}
                        loading="lazy"
                    />
                    <h3 className="font-grotesk-bold">Our groceries</h3>
                    <p>
                        We directly source high-quality groceries at great prices including fresh produce, meat and
                        seafood, healthy snacks, rescued foods, and more! New items and deals are added each week.
                    </p>
                </div>
                <div className="text-body-sm flex flex-1 flex-col gap-10">
                    <img
                        alt="Hand holding phone with Misfits Market shopping experience on screen"
                        src={`${BOYSENBERRY_S3_IMAGES}signup/mm-shop-mobile.png`}
                        width={650}
                        height={650}
                        loading="lazy"
                    />
                    <h3 className="font-grotesk-bold">Shopping with Misfits Market</h3>
                    <p>
                        Create your FREE account and start shopping during your weekly shopping window. We’ll add a
                        curated selection of items to your cart to get you started.
                    </p>
                </div>
                <div className="text-body-sm flex flex-1 flex-col gap-10">
                    <img
                        alt="Delivery driver holding a Misfits Market box"
                        src={`${BOYSENBERRY_S3_IMAGES}signup/mm-delivery-van.png`}
                        width={742}
                        height={742}
                        loading="lazy"
                    />
                    <h3 className="font-grotesk-bold">Easy delivery</h3>
                    <p>
                        Once your shopping window closes, your order will be confirmed and delivered. Need to skip a
                        week? No problem! Skip your order anytime, no charge.
                    </p>
                </div>
            </div>

            {renderSignUpCTA && (
                <div className="md:mx-auto md:max-w-[350px]">
                    <Button size="lg" as="link" to="/join" onClick={onSignUpCTAClick}>
                        Sign Up to Shop
                    </Button>
                </div>
            )}
        </section>
    );
}

ProspectModule.propTypes = {
    onSignUpCTAClick: PropTypes.func,
    renderSignUpCTA: PropTypes.bool,
};

ProspectModule.defaultProps = {
    onSignUpCTAClick: null,
    renderSignUpCTA: false,
};

export default ProspectModule;
